import callApi, { CallApiResult } from 'src/api';

export const fetchOrderProductsByOfferOrderId = (offerOrderId: string): Promise<CallApiResult> => {
    const endpoint = `/ordering/` + offerOrderId;
    return callApi(endpoint);
};
